const URL_PATTERN = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]}>»"']+$/;

const stripTrailingPunctuation = value => {
    const match = String(value || '').match(TRAILING_PUNCTUATION);
    if (!match) {
        return {
            url: String(value || ''),
            trailing: ''
        };
    }
    return {
        url: String(value || '').slice(0, -match[0].length),
        trailing: match[0]
    };
};

export const normalizeChatLinkHref = rawUrl => {
    const candidate = String(rawUrl || '').trim();
    if (!candidate) {
        return null;
    }

    const withProtocol = /^https?:\/\//i.test(candidate)
        ? candidate
        : `https://${candidate}`;

    try {
        const parsed = new URL(withProtocol);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return null;
        }
        return parsed.href;
    } catch (e) {
        return null;
    }
};

export const parseChatMessageLinks = text => {
    const source = String(text || '');
    if (!source) {
        return [];
    }

    const parts = [];
    let lastIndex = 0;
    URL_PATTERN.lastIndex = 0;

    let match = URL_PATTERN.exec(source);
    while (match) {
        const fullMatch = match[0];
        const start = match.index;

        if (start > lastIndex) {
            parts.push({
                type: 'text',
                value: source.slice(lastIndex, start)
            });
        }

        const { url, trailing } = stripTrailingPunctuation(fullMatch);
        const href = normalizeChatLinkHref(url);
        if (href && url) {
            parts.push({
                type: 'link',
                value: url,
                href
            });
            if (trailing) {
                parts.push({
                    type: 'text',
                    value: trailing
                });
            }
        } else {
            parts.push({
                type: 'text',
                value: fullMatch
            });
        }

        lastIndex = start + fullMatch.length;
        match = URL_PATTERN.exec(source);
    }

    if (lastIndex < source.length) {
        parts.push({
            type: 'text',
            value: source.slice(lastIndex)
        });
    }

    return parts.length ? parts : [{ type: 'text', value: source }];
};

export default {
    normalizeChatLinkHref,
    parseChatMessageLinks
};
